"use strict";
/*******************************************************************************

    Contains a class that enables integrated management of necessary classes
    in a wallet with multiple accounts.

    Copyright:
        Copyright (c) 2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletMA = void 0;
var Account_1 = require("./Account");
var WalletClient_1 = require("./WalletClient");
var WalletWatcher_1 = require("./WalletWatcher");
/**
 * It is a Wallet with Multi Accounts
 * It is a class that enables integrated management of necessary classes in a wallet with multiple accounts.
 */
var WalletMA = /** @class */ (function () {
    /**
     * Constructor
     * @param endpoint The endpoints of wallet
     */
    function WalletMA(endpoint) {
        this.client = new WalletClient_1.WalletClient(endpoint);
        this.accounts = new Account_1.AccountContainer(this.client);
        this.watcher = new WalletWatcher_1.WalletWatcher(this.accounts, this.client, 10000);
        this.builders = new Map();
        this.watcher.initialize();
    }
    /**
     * Set the endpoints of wallet, Agora's endpoint & Stoa's endpoint
     * @param endpoint The endpoints of wallet
     */
    WalletMA.prototype.setEndpoint = function (endpoint) {
        this.client.setEndpoint(endpoint);
    };
    /**
     * Get the endpoints of wallet
     * @return The endpoints of wallet
     */
    WalletMA.prototype.getEndpoint = function () {
        return this.client.getEndpoint();
    };
    /**
     * This function always allows access to only one object.
     */
    WalletMA.instance = function () {
        if (WalletMA._instance === null) {
            WalletMA._instance = new WalletMA(WalletMA.default_endpoint);
        }
        return WalletMA._instance;
    };
    /**
     * It is necessary to preset the options required when an object is created.
     * @param default_endpoint The endpoint of default
     */
    WalletMA.setDefaultEndpoint = function (default_endpoint) {
        WalletMA.default_endpoint = default_endpoint;
    };
    WalletMA._instance = null;
    WalletMA.default_endpoint = {
        agora: "http://127.0.0.1:2826",
        stoa: "http://127.0.0.1:3836",
    };
    return WalletMA;
}());
exports.WalletMA = WalletMA;
//# sourceMappingURL=WalletMA.js.map